export default {
  name: "Core",
  setup: function setup() {}
};